/**
 * @name: dict
 * @description:
 * @author: qq2575896094
 * @time: 2024/3/26
 */

const prefix = '/onlinecs/dict'

export default {
    getDictListUrl: `${prefix}/getDictList`,
    getDictTreeUrl: `${prefix}/tree`
}
